import styled from 'styled-components';

const StyledMedicalLeaveFormTableToggle = styled.div`
   margin-left: auto;
`;
StyledMedicalLeaveFormTableToggle.displayName = 'StyledMedicalLeaveFormTableToggle';

export { StyledMedicalLeaveFormTableToggle };
